import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DemoVehiclesRequest } from '../../models/demo-request.model';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DemoStockFiltersComponent } from '../../components/demo-stock-filters/demo-stock-filters.component';
import {
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsProgressCircleModule,
  DsSelectModule,
  DsTableModule,
} from '@bmw-ds/components';
import { config, take } from 'rxjs';
import { CriteriaResponse } from '../../models/criteria.model';
import { CriteriaService } from '../../services/criteria.service';
import { CriteriaStoreService } from '../../services/criteria-store.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-demo-stock',
  templateUrl: './demo-stock.component.html',
  imports: [
    BreadcrumbComponent,
    DemoStockFiltersComponent,
    DsTableModule,
    DsSelectModule,
    DsProgressCircleModule,
  ],
  styleUrl: './demo-stock.component.scss',
})
export class DemoStockComponent implements OnInit {
  filters: DemoVehiclesRequest = {
    iv_user: '',
    plant: '',
    model: '',
    version: '',
    materialNr: [],
  };
  demoRequest: DemoVehiclesRequest = {
    iv_user: '',
    plant: '',
    model: '',
    version: '',
    materialNr: [],
  };
  loadingAreaConfig: DsLoadingAreaConfiguration = { id: 'bodyLoading' };
  criteriaData!: CriteriaResponse;

  constructor(
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly criteriaService: CriteriaService,
    private readonly criteriaStoreService: CriteriaStoreService,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.authService.isAuthenticated().pipe(take(1)).subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.loadCriteriaData(localStorage.getItem('dealerCode') ?? '');
      } else {
        window.location.href = this.authService.getAuthUrl();
      }
    });
  }

  loadCriteriaData(dealerCode: string): void {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.criteriaService.postCriteriaSelection(dealerCode).subscribe({
      next: (data: CriteriaResponse) => {
        this.criteriaData = data;
        this.cdr.detectChanges();
        this.criteriaStoreService.setCriteriaData(data);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      error: (error: unknown) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.error('Error fetching criteria data', error);
      },
    });
  }

  onFiltersChanged(payload: DemoVehiclesRequest): void {
    console.log('payload', payload);
    this.demoRequest = payload;
  }

  protected readonly config = config;
}
